// "superuser" is a fake group to represent a superuser.
export const USER_GROUP_SUPERUSER = "superuser";
